// Real Estate appointments — docs/real-estate/be/10-api-reference.md §A13.
// Same refetch-after-write pattern as store/modules/realEstate.js: a
// status change, reschedule or edit can change `status_counts` (the tab
// badges) as well as the row itself, so every write just re-runs the last
// list query instead of trying to patch the cache in place.
import {
  listAppointments,
  createAppointment,
  patchAppointment,
  setAppointmentStatus,
  rescheduleAppointment,
  deleteAppointment,
} from '../../api/realEstate/appointments';

export const state = {
  results: [],
  total: 0,
  page: 1,
  pageSize: 20,
  statusCounts: {},
  query: {},
};

export const mutations = {
  setList(moduleState, { data, query }) {
    moduleState.results = data.results;
    moduleState.total = data.total;
    moduleState.page = data.page;
    moduleState.pageSize = data.page_size;
    moduleState.statusCounts = data.status_counts;
    moduleState.query = query;
  },
};

export const getters = {
  getResults: moduleState => moduleState.results,
  getTotal: moduleState => moduleState.total,
  getPage: moduleState => moduleState.page,
  getPageSize: moduleState => moduleState.pageSize,
  getStatusCounts: moduleState => moduleState.statusCounts,
};

async function refreshList({ commit, state: moduleState }) {
  const { data } = await listAppointments(moduleState.query);
  commit('setList', { data, query: moduleState.query });
  return data;
}

export const actions = {
  async fetchAppointments({ commit }, query) {
    const { data } = await listAppointments(query);
    commit('setList', { data, query });
    return data;
  },
  // Doesn't refresh the list itself — a new appointment might not match
  // the current tab/filters (e.g. created while viewing "Confirmed"), so
  // the caller re-fetches with whatever query it wants after this.
  async addAppointment(context, fields) {
    const { data } = await createAppointment(fields);
    return data;
  },
  async patchAppointment({ commit, state: moduleState }, { id, fields }) {
    await patchAppointment(id, fields);
    return refreshList({ commit, state: moduleState });
  },
  async setAppointmentStatus(
    { commit, state: moduleState },
    { id, status, reason }
  ) {
    await setAppointmentStatus(id, status, reason);
    return refreshList({ commit, state: moduleState });
  },
  async rescheduleAppointment({ commit, state: moduleState }, { id, fields }) {
    await rescheduleAppointment(id, fields);
    return refreshList({ commit, state: moduleState });
  },
  async deleteAppointment({ commit, state: moduleState }, id) {
    await deleteAppointment(id);
    return refreshList({ commit, state: moduleState });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
